// src/StepperComponent.js
import React, { useEffect, useState } from 'react';
import Stepper from "@keyvaluesystems/react-stepper";
import { useSelector } from 'react-redux';


const StepperComponent = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const { user } = useSelector((state) => state.profile);
  // const initialStepsArr = [
  //   {
  //     stepLabel: "Registration Completed",
  //     // stepDescription: "Add your delivery address",
  //     completed: true,
  //   },
  //   {
  //     stepLabel: "Complete your profile",
  //     // stepDescription: "Add your mode of payment",
  //     completed: user?.fld_verifydoc===2 ?true:false,
  //   },
  //   {
  //     stepLabel: "Onboarding Call",
  //     // stepDescription: "Verify your order details",
  //     completed: (user?.fld_onboardstatus=="Contacted" || user?.fld_onboardstatus=="Approved") ?true:false,
  //   },
  //   {
  //     stepLabel: "Get Started",
  //     // stepDescription: "Verify your order details",
  //     completed: (user?.fld_verifydoc===2 && user?.fld_onboardstatus=="Approved") ?true:false,
  //   },
  // ];


  // Step configuration with dynamic ordering
  // Default steps with all "false"
  let initialStepsArr = [
    {
      stepLabel: "Registration Completed",
      completed: true,
    },
    {
      stepLabel: "Complete your profile",
      completed: false,
    },
    {
      stepLabel: "Onboarding Call",
      completed: false,
    },
    {
      stepLabel: "Get Started",
      completed: false,
    },
  ];
  
  // Update steps based on user conditions
  if (user?.fld_verifydoc === 2 || user?.fld_verifydoc === 1){
    initialStepsArr[1].completed = true;
  }
  
  if (user?.fld_onboardstatus === "Contacted" || user?.fld_onboardstatus === "Approved" || user?.fld_onboardstatus === "Employee") {
    initialStepsArr[2].completed = true;
  }
  
  // Reorder steps so completed ones come first
  initialStepsArr.sort((a, b) => b.completed - a.completed);
  

  

  // Dynamically set the current step based on the last completed step
  useEffect(() => {
    const lastCompletedIndex = initialStepsArr.findLastIndex((step) => step.completed);
    setCurrentStep(lastCompletedIndex + 1); // Move to the next step
  }, [user]);

  const stepperStyles = {
    LabelTitle: () => ({
      fontSize: "10px", // Default font size
      "@media (max-width: 768px)": {
        fontSize: "10px !important", // Font size for mobile view
      },
    }),

    CompletedNode: () => ({
      backgroundColor: "#24324a",
    }),
    // Add other style overrides here if needed
  };
  return (
    <div className="App mx-3">
    

      {/* <h3>Horizontal Stepper</h3> */}
      <div>
      <Stepper
        steps={initialStepsArr}
        currentStepIndex={currentStep}
        orientation={"horizontal"}
        labelPosition="bottom"
        styles={stepperStyles}
      />
    </div>
    </div>
  );


};

export default StepperComponent;